import axios from 'axios';
import { getSession } from './session.js';
import { CURRENT_LANG, LIVE_API_ENDPOINT, LOCAL_API_ENDPOINT, REACT_APP_STAGE, TEST_API_ENDPOINT } from './config.js';

let SIBILUS_API_URL = LOCAL_API_ENDPOINT;

if (
	window.location.hostname === 'pentus.dk'
) {
	SIBILUS_API_URL = LIVE_API_ENDPOINT;
} else if (REACT_APP_STAGE === "build") {
	SIBILUS_API_URL = TEST_API_ENDPOINT;
}

export const APIGet = (resource, params = {}) => {
	const session_id = getSession()
	const url = SIBILUS_API_URL + resource;
	const options = { params, headers: {} };
	options['headers']['X-Traks-Lan'] = CURRENT_LANG
	if (session_id) {
		options['headers']['X-Session-Id'] = session_id || '';
		options['headers']['Accept'] = 'application/json'
	}

	return axios({ url, method: 'get', ...options });
};

export const APIPost = (
	resource,
	body,
	headers = { 'Content-Type': 'application/json' }
) => {
	const session_id = getSession()
	const url = SIBILUS_API_URL + resource;
    headers['X-Traks-Lan'] = CURRENT_LANG
	if (session_id) {
		headers['X-Session-Id'] = session_id || '';
	}

	return axios({ url, method: 'post', data: body, headers });
};
export const APIDelete = (resource, data = {}) => {
	const session_id = getSession()
	const url = SIBILUS_API_URL + resource;
	const headers = {};
	headers['X-Traks-Lan'] = CURRENT_LANG
	if (session_id) {
		headers['X-Session-Id'] = session_id || '';
	}

	return axios({ url, method: 'delete', data, headers });
};

export const APIPut = (resource, data = {}) => {
	const session_id = getSession()
	const url = SIBILUS_API_URL + resource;
	const headers = {};
	headers['X-Traks-Lan'] = CURRENT_LANG
	if (session_id) {
		headers['X-Session-Id'] = session_id || '';
	}
	return axios({ url, method: 'put', data, headers });
};

